import VueCookie from 'vue-cookie';
import axios from 'axios';
import router from "../../router/routes";

const COOKIE_FIELD_VALUE_STRING = 'value=';

const GAInterceptors = async function (config) {

    let token = '';
    token = getTokenFromCookie();

    token = await Checktoken(token);

    config.headers.common['X-FERCAM-GLOBAL-AUTH'] = token;
    return config;
};

async function Checktoken(token) {

    let appCode = process.env.VUE_APP_CLIENTID;

    if (!token) {
        // console.log("token doesn't exist");

        router.push({ name: "unauthorized" }).catch(err => { });

        return;
    }
    // else
    //   console.log("token exists", token);

    if (tokenIsExpired(token)) {
        await fetch(`${process.env.VUE_APP_GLOBALAUTH_API}Login/RefreshToken/${token}`,)
            .then(async response => {
                const newToken = await response.json();
                // console.log("tokendata", newToken);

                if (!response.ok) {
                    const error = (newToken && newToken.message) || response.statusText;
                    // console.log("error", error);

                    router.push({ name: "unauthorized" }).catch(err => { });
                    return;
                }
                else {
                    refreshToken(newToken);
                    token = newToken;
                }
            })
            .catch((err) => {
                console.log(err);

                router.push({ name: "unauthorized" }).catch(err => { });
                return;
            });
    }

    // console.log("new token", token);
    var globalauth_session = sessionStorage.getItem("GlobalAuthUser");
    // console.log("globalauth_session", JSON.parse(globalauth_session));
    if (!globalauth_session) {
        // console.log("global auth session empty");
        await fetch(`${process.env.VUE_APP_GLOBALAUTH_API}Login/GetUserDataNew/${token}/${appCode}`,)
            .then(async response => {
                const data = await response.json();
                // console.log("data", data, "response", response);
                // check for error response
                if (!response.ok) {
                    // get error message from body or default to response statusText
                    const error = (data && data.message) || response.statusText;
                    //console.log("error", error, "user", this.user);

                    router.push({ name: "unauthorized" }).catch(err => { });
                    return;
                }
                else {

                    let user = {
                        username: "",
                        firstname: "",
                        lastname: "",
                        branchCode: "",
                        isAuthenticated: false,
                        gaFunctions: []
                    };

                    user.username = data.username;
                    user.branchCode = data.branchCode;
                    user.firstname = data.firstName;
                    user.lastname = data.lastName;
                    user.isAuthenticated = true;
                    user.gaFunctions = data.functions;

                    // console.log("user data", data, user);
                    sessionStorage.setItem("GlobalAuthUser", JSON.stringify(user));
                }
            })
            .catch(error => {
                router.push({ name: "unauthorized" }).catch(err => { });
            });
    }
    else {
        // console.log("session is already present", JSON.parse(globalauth_session));
    }

    return token;
}

let isAlreadyFetchingAccessToken = false;
const GAInterceptorsOnError = function (error) {
    const {
        config,
        response: { status },
    } = error;

    const originalRequest = config;
    // console.log("response error", error);
    if (status === 401) {
        console.log("status 401");
        if (!isAlreadyFetchingAccessToken) {
            isAlreadyFetchingAccessToken = true;
            const token = getTokenFromCookie();
            // console.log("refresh token", token);
            fetch(
                `${process.env.VUE_APP_GLOBALAUTH_API}Login/RefreshToken/${token}`,
                
            )
                .then(response => response.json())
                .then((newToken) => {
                    if (newToken) {
                        //console.log("newtoken", newToken);
                        refreshToken(newToken);
                        onRrefreshed(newToken);
                    }
                })
                .catch((err) => {
                    console.log(err);
                });
        }
        //console.log("already fetched", token);
        const retryOriginalRequest = new Promise((resolve) => {
            subscribeTokenRefresh((token) => {
                originalRequest.headers['X-FERCAM-GLOBAL-AUTH'] = token;
                //console.log("retryOriginalRequest", token);
                resolve(axios(originalRequest));
            });
        });
        return retryOriginalRequest;
    }
    return Promise.reject(error);

};

var getTokenFromCookie = function () {
    const cookieValue = VueCookie.get('GlobalAuthUser');
    //console.log("getTokenFromCookie", cookieValue);
    if (cookieValue) {
        const token = cookieValue
            .split('&')
            .find(s => s.indexOf(COOKIE_FIELD_VALUE_STRING) > -1)
            .replace(COOKIE_FIELD_VALUE_STRING, '');
        return token;
    }
    return '';

};

var refreshToken = function (token) {
    const cookieValue = VueCookie.get('GlobalAuthUser');
    //console.log("refresh token", cookieValue);
    const GACookie = cookieValue.split('&');
    if (GACookie) {
        GACookie[0] = COOKIE_FIELD_VALUE_STRING + token;

        var currentDomain = window.location.hostname.split('.').reverse().slice(0,2).reverse().join("."); 

        const newCookie = GACookie.join('&');
        document.cookie = `GlobalAuthUser=${newCookie};domain=${currentDomain};expires=${now.toUTCString()};path=/`;
        //console.log("document.cookie", document.cookie);
    }
};

const refreshSubscribers = [];

function subscribeTokenRefresh(cb) {
    //console.log("subscribeTokenRefresh", cb);
    refreshSubscribers.push(cb);
}

function onRrefreshed(token) {
    //console.log("onRrefreshed", token);
    refreshSubscribers.map(cb => cb(token));
}

var tokenIsExpired = function (token) {
    var ticks = atob(token).split(':')[2];

    var ticksnow = ((Date.now() * 10000) + 621355968000000000);

    let refreshtoken = ticksnow > ticks;

    //console.log("must refresh token", refreshtoken);

    return refreshtoken;

};

export default { GAInterceptors, GAInterceptorsOnError };
